import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import {
  UPLOAD_DIALOG_STYLES,
  UPLOAD_DIALOG_COLORS,
  ALLOWED_EXTENSIONS,
} from '../../../../../common/styles/dialogStyles';

interface DropZoneProps {
  isDragOver: boolean;
  onBrowse: () => void;
  onDragOver: (event: React.DragEvent) => void;
  onDragLeave: (event: React.DragEvent) => void;
  onDrop: (event: React.DragEvent) => void;
}

export const DropZone: React.FC<DropZoneProps> = ({
  isDragOver,
  onBrowse,
  onDragOver,
  onDragLeave,
  onDrop,
}) => (
  <Paper
    sx={{
      ...UPLOAD_DIALOG_STYLES.uploadArea,
      ...(isDragOver && UPLOAD_DIALOG_STYLES.uploadAreaDragOver),
    }}
    onClick={onBrowse}
    onDragOver={onDragOver}
    onDragLeave={onDragLeave}
    onDrop={onDrop}
  >
    <CloudUpload
      sx={{
        fontSize: 48,
        color: isDragOver ? UPLOAD_DIALOG_COLORS.primary : UPLOAD_DIALOG_COLORS.textPlaceholder,
        mb: 2,
      }}
    />
    <Typography
      variant="h6"
      sx={{
        mb: 1,
        color: isDragOver ? UPLOAD_DIALOG_COLORS.primary : UPLOAD_DIALOG_COLORS.textSecondary,
      }}
    >
      {isDragOver ? 'Drop files here' : 'Click to browse files'}
    </Typography>
    <Typography
      variant="body2"
      sx={{ color: UPLOAD_DIALOG_COLORS.textMuted, mb: 2 }}
    >
      {isDragOver ? 'Release to add files' : 'or drag and drop files here'}
    </Typography>
    <Typography variant="caption" sx={{ color: UPLOAD_DIALOG_COLORS.textPlaceholder }}>
      Supported formats: {ALLOWED_EXTENSIONS.join(', ')} • Max size: 10MB per file
    </Typography>
  </Paper>
);

export default DropZone;
